import { useState } from "react";

export default function SignupAgreement({
  userType,
  onAgree,
  onBack,
}: {
  userType: string;
  onAgree: () => void;
  onBack: () => void;
}) {
  const [checked, setChecked] = useState(false);

  return (
    <div className="max-w-md mx-auto mt-20 p-8 shadow rounded bg-white">
      <h2 className="text-2xl font-bold mb-6 text-center">개인정보 수집 및 이용 동의</h2>

      <div className="border rounded p-4 mb-6 h-48 overflow-auto text-sm bg-gray-50">
        <ul className="list-disc pl-4 space-y-2">
          <li>
            [필수] <a href="/terms/AgeConfirmTerms" target="_blank" className="underline text-blue-600">만 14세 이상입니다</a>
          </li>
          <li>
            [필수] <a href="/terms/ServiceTerms" target="_blank" className="underline text-blue-600">서비스 이용약관에 동의합니다</a>
          </li>
          <li>
            [필수] <a href="/terms/PrivacyTerms" target="_blank" className="underline text-blue-600">개인정보 처리방침에 동의합니다</a>
          </li>
        </ul>
      </div>

      <label className="flex items-center mb-4">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
          className="mr-2"
        />
        모두 동의합니다.
      </label>

      <div className="flex justify-between">
        <button className="text-gray-500" onClick={onBack}>이전</button>
        <button
          className="bg-black text-white px-6 py-2 rounded disabled:bg-gray-300"
          disabled={!checked}
          onClick={onAgree}
        >
          다음
        </button>
      </div>
    </div>
  );
}
